<template>
  <div class="shippingPlan bg_white">
    <div class="shippingPlan_wrap bg_white mt12">
      <h1 class="shippingPlan_title rb c5a">今後の配送プラン</h1>
    </div>

    <!-- ローディング表示 -->
    <Loading v-if="loading" />
    <div v-if="loading" class="loading bg_white mt12 pt16 pb16">
      <p class="text-center">配送プランを作成中...</p>
    </div>

    <!-- データがない場合の表示 -->
    <div v-else-if="planList.length === 0" class="no-data bg_white mt12 pt16 pb16">
      <p class="text-center">配送プランデータがありません。</p>
    </div>
    <div v-for="(value, n) in planList" v-bind:class="[n != 0 ? 'mt12' : '']" class="planList_wrap bg_white pt16 pb16 boxs1" :key="n">
      <h2 class="planList_title ab"><span class="month rb">{{ value.targetMonth.slice(0, -1) }}</span></h2>
      <div v-if="value.hasDetail" class="ml16 mr16">
        <!-- BCごとにグループ化して表示 -->
        <div v-for="(bcGroup, bcNo) in value.groupedByBC" :key="bcNo" class="bc-group mt16">
          <h3 class="bc-title rb">BC: {{ bcNo }}</h3>
          <div v-for="(product, index) in bcGroup" class="planList_item ml16 mr16 bdb" :key="index">
            <p class="planList_item--title rb c5a">{{ product.productName }}</p>
            <div class="planList_item--detail">
              <p class="planList_item--count ar">数量<span class="count rm">{{ product.orderCount }}</span></p>
              <p class="planList_item--payment rb">{{ product.paymentMethodName }}</p>
              <p class="planList_item--status rb c5a">{{ product.shipmentStatus }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="ml16 mr16 mt16">
        <p class="rb c5a">{{ value.textOfEmptyList }}</p>
      </div>
    </div>
    <div class="btn_wrap bg_white mt12">
      <router-link class="btn_blue" :to="{ name: 'multiSubConfirm' }">次へ</router-link>
      <router-link class="btn_delete back_btn" :to="{ name: 'multiSubSelectProductsList' }">戻る</router-link>
    </div>
  </div>
</template>

<script>
import RepeatOrder from '@/components/api/repeatOrder'
import Loading from '@/components/common/Loading'
import { mapGetters } from 'vuex'

export default {
  components: {
    Loading
  },
  data() {
    return {
      planList: [],
      loading: false
    }
  },
  methods: {
    async simulateMonthly() {
      this.loading = true;

      try {
        const multiBcOrderData = this.recommendationMultiBcOrderData;
        console.log('simulateMonthly called with:', multiBcOrderData);

        if (multiBcOrderData && Object.keys(multiBcOrderData).length > 0) {
          // API仕様に従ってリクエストデータを構築
          const requestData = {
            bcRepeatOrderMap: multiBcOrderData
          };
          console.log('simulateMonthly request:', requestData);

          const response = await RepeatOrder.simulateMonthly(requestData);
          console.log('API response:', response);

          // シミュレーション結果をVuexに保存
          this.$store.commit('setRecommendationSimulationResult', response);

          // シミュレーション結果を表示用に変換
          this.processSimulationResult(response);
        }
      } catch (error) {
        console.error('シミュレーションエラー:', error);
      } finally {
        this.loading = false;
      }
    },
    processSimulationResult(response) {
      // APIレスポンスを画面表示用に変換
      this.planList = [];

      console.log('Processing simulation result:', response);

      if (response.bcRepeatOrderMap) {
        // 新しいレスポンス形式：各BCが月別データの配列を持つ
        const allMonthlyPlans = [];

        // 各BCのデータを統合
        for (const bcNo in response.bcRepeatOrderMap) {
          const bcMonthlyData = response.bcRepeatOrderMap[bcNo];

          if (Array.isArray(bcMonthlyData)) {
            // 各月のデータをそのまま使用（既に適切な形式）
            bcMonthlyData.forEach(monthData => {
              console.log(`Processing BC:${bcNo}, Month:${monthData.targetMonth}, intNextMonth:${monthData.intNextMonth}`);

              // intNextMonthで同じ月のデータを探す
              const existingMonth = allMonthlyPlans.find(
                plan => plan.intNextMonth === monthData.intNextMonth
              );

              if (existingMonth) {
                console.log(`Adding BC:${bcNo} to existing month:${existingMonth.targetMonth}`);
                // 既存の月にBCのデータを追加（BC番号を付与）
                if (monthData.hasDetail && monthData.detailList) {
                  const detailListWithBC = monthData.detailList.map(item => ({
                    ...item,
                    bcNo: bcNo
                  }));
                  existingMonth.detailList.push(...detailListWithBC);
                  existingMonth.hasDetail = true;
                }
              } else {
                console.log(`Creating new month entry for BC:${bcNo}, Month:${monthData.targetMonth}`);
                // 新しい月のデータを追加
                // targetMonthに「分」が含まれていない場合のみ追加
                const targetMonth = monthData.targetMonth.includes('分') ?
                  monthData.targetMonth : monthData.targetMonth + '分';

                // detailListにBC番号を付与
                const detailListWithBC = monthData.detailList ?
                  monthData.detailList.map(item => ({
                    ...item,
                    bcNo: bcNo
                  })) : [];

                allMonthlyPlans.push({
                  targetMonth: targetMonth,
                  hasDetail: monthData.hasDetail,
                  detailList: detailListWithBC,
                  textOfEmptyList: monthData.textOfEmptyList || 'お届けなし',
                  intNextMonth: monthData.intNextMonth,
                  groupedByBC: {}
                });
              }
            });
          }
        }

        // 月順にソート（intNextMonthを使用）
        allMonthlyPlans.sort((a, b) => {
          const monthA = a.intNextMonth || 0;
          const monthB = b.intNextMonth || 0;
          return monthA - monthB;
        });

        // 各月のデータをBCごとにグループ化
        allMonthlyPlans.forEach(monthPlan => {
          if (monthPlan.hasDetail && monthPlan.detailList) {
            monthPlan.groupedByBC = monthPlan.detailList.reduce((groups, item) => {
              const bcNo = item.bcNo || '001';
              if (!groups[bcNo]) {
                groups[bcNo] = [];
              }
              groups[bcNo].push(item);
              return groups;
            }, {});
          }
        });

        this.planList = allMonthlyPlans;
        console.log('Processed planList:', this.planList);
        console.log('Final planList length:', this.planList.length);
        this.planList.forEach((plan, index) => {
          console.log(`Plan ${index}: Month=${plan.targetMonth}, BCGroups=`, Object.keys(plan.groupedByBC));
        });
      }
    },
  },
  computed: mapGetters([
    'recommendationMultiBcOrderData'
  ]),
  async created() {
    // 既存のローカルストレージからの読み込み
    let simulate = JSON.parse(localStorage.getItem('recommendationSimulationResponse'));

    if (simulate) {
      this.planList.push(...simulate);
    } else {
      // 新しいシミュレーションAPI呼び出し
      if (this.recommendationMultiBcOrderData && Object.keys(this.recommendationMultiBcOrderData).length > 0) {
        await this.simulateMonthly();
      }
    }
  }
}
</script>

<style lang="css" scoped>
.shippingPlan_wrap {
  padding: 12px 0;
}
.shippingPlan_title {
  font-size: 14px;
  line-height: 1;
  text-align: center;
}

.planList_title {
  background-color: #4FCCD4;
  color: #fff;
  font-size: 18px;
  padding: 6.5px;
  text-align: center;
}

.planList_title .month {
  font-size: 30px;
}

.bc-group {
  margin-bottom: 10px;
}

.bc-title {
  font-size: 16px;
}

.planList_item {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  padding-bottom: 8px;
  flex-direction: column;
}
.planList_item--title {
  font-size: 16px;
  width: 100%;
}
.planList_item--detail {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  width: 100%;
}

.planList_item--count {
  font-size: 13px;
}
.planList_item--count .count {
  font-size: 17px;
  margin-left: 5px;
}
.planList_item--payment {
  font-size: 13px;
}
.planList_item--status {
  font-size: 13px;
}
.shippingPlan_text {
  color: #ff0000;
  font-size: 14px;
  line-height: 1.5;
  padding: 0 16px;
}

.btn_wrap {
  padding: 32px 0 80px;
}

.btn_blue {
  margin-top: 48px;
}

.loading, .no-data {
  text-align: center;
  padding: 32px 16px;
}

.text-center {
  text-align: center;
  color: #666;
}

.bc-label {
  display: inline-block;
  background-color: #4FCCD4;
  color: #fff;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  margin-right: 8px;
  font-weight: bold;
}

.ml32 {
  margin-left: 32px;
}
</style>



// WEBPACK FOOTER //
// src/views/subscriptionMultiBc/ShippingPlan.vue